var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// api/geschaeftsvorfall-buchung.ts
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { Buchung } from "./buchung.js";
import { Geschaeftsvorfall } from "./geschaeftsvorfall.js";
var GeschaeftsvorfallBuchung = class extends Buchung {
  /**
   * Leistung an Kunden
   *
   * @param debitorenKonto Zahlender
   * @param kreditorenKonto empfangendes Konto (Umsatzkonto)
   * @param buchung restliche Attribute einer Buchung
   * @param geschaeftsvorfallID Zuweisung zu einem best. Geschäftsvorfall. Wenn nicht gegeben, wird ein neuer Vorfall angelegt
   * @returns die Buchung
   */
  static async erstelleGeschaeftsvorfallDebitorenForderung(debitorenKonto, kreditorenKonto, buchung, geschaeftsvorfallID) {
    if (!geschaeftsvorfallID) {
      const geschaeftsvorfall = new Geschaeftsvorfall({});
      geschaeftsvorfallID = await geschaeftsvorfall.create();
    }
    return new this({ ...buchung, sollKonto: debitorenKonto, habenKonto: kreditorenKonto, geschaeftsvorfallID });
  }
  /**
   * Invertiert soll- und haben-konto der Forderung
   */
  static bucheZahlung(forderung, zahlung) {
    return new this({
      ...zahlung,
      habenKonto: forderung.sollKonto,
      sollKonto: forderung.habenKonto,
      geschaeftsvorfallID: forderung.geschaeftsvorfallID
    });
  }
};
GeschaeftsvorfallBuchung._class = "GeschaeftsvorfallBuchung";
__decorateClass([
  Field((type) => String)
], GeschaeftsvorfallBuchung.prototype, "geschaeftsvorfallID", 2);
GeschaeftsvorfallBuchung = __decorateClass([
  Entity()
], GeschaeftsvorfallBuchung);
export {
  GeschaeftsvorfallBuchung
};
